import React from "react";
import { Button, Field, Select, inputStyle } from "../UI";
import { displayPersonName } from "../../utils/recruiterUtils";

export default function InterviewFeedbackModal({
  selectedCandidate,
  feedbackStatus,
  setFeedbackStatus,
  feedbackText,
  setFeedbackText,
  feedbackRating,
  setFeedbackRating,
  busy,
  theme,
  fonts,
  onClose,
  onSubmit
}) {
  if (!selectedCandidate) return null;

  return (
    <div style={{
      position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0,0,0,0.65)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 20, zIndex: 1100
    }}>
      <div style={{ background: theme.surface, border: `1px solid ${theme.line}`, borderRadius: 14, padding: 28, width: "100%", maxWidth: 460, boxShadow: "0 24px 60px rgba(0,0,0,0.3)" }}>
        <div style={{ marginBottom: 14 }}>
          <h3 style={{ fontSize: 18, fontWeight: 700, margin: "0 0 4px", fontFamily: fonts?.display }}>Interview Feedback & Hiring Decision</h3>
          <div style={{ fontSize: 13, color: theme.accent, fontWeight: 700 }}>
            Candidate: {typeof selectedCandidate === "object" ? (displayPersonName(selectedCandidate) || selectedCandidate.candidate_name || selectedCandidate.name || "Candidate") : "Candidate"}
          </div>
          {typeof selectedCandidate === "object" && (selectedCandidate.job_role || selectedCandidate.role) && (
            <div style={{ fontSize: 12, color: theme.textMute, marginTop: 2 }}>
              For Role: {selectedCandidate.job_role || selectedCandidate.role}
            </div>
          )}
        </div>
        <form onSubmit={onSubmit}>
          <Field label="Hiring Status Decision" theme={theme}>
            <Select
              theme={theme}
              value={feedbackStatus}
              onChange={e => setFeedbackStatus(e.target.value)}
              options={[
                { value: "hired", label: "Hired (Candidate Selected)" },
                { value: "rejected", label: "Rejected" },
                { value: "shortlisted", label: "Shortlisted (Under Interview Review)" }
              ]}
            />
          </Field>
          <Field label="Recruiter Feedback & Remarks" theme={theme}>
            <textarea required style={{ ...inputStyle(theme), minHeight: 85, resize: "vertical" }} value={feedbackText} onChange={e => setFeedbackText(e.target.value)} placeholder="Provide interview evaluation and feedback notes..." />
          </Field>
          <Field label="Interview Performance Rating (1 to 10)" theme={theme}>
            <Select
              theme={theme}
              value={String(feedbackRating)}
              onChange={e => setFeedbackRating(parseInt(e.target.value, 10))}
              options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => ({ value: String(n), label: `${n} / 10 ${n >= 8 ? '— Excellent' : n >= 6 ? '— Good' : '— Needs Review'}` }))}
            />
          </Field>
          <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
            <Button type="button" theme={{ ...theme, surface: theme.line }} onClick={onClose} style={{ flex: 1, justifyContent: "center", background: "transparent", border: `1px solid ${theme.line}`, color: theme.text }}>Cancel</Button>
            <Button type="submit" theme={theme} style={{ flex: 2, justifyContent: "center", background: feedbackStatus === "hired" ? "#16a34a" : (feedbackStatus === "rejected" ? "#dc2626" : theme.accent), color: "#fff" }} disabled={busy}>
              {busy ? "Saving..." : (feedbackStatus === "hired" ? "Confirm Hire & Add to Hires" : "Save Decision")}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
